<script lang="ts" setup>
import { ShiftCMSState } from '@/store';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState>();
const route = useRoute();
const router = useRouter();

const token = computed(() => store.state.token);

function showContent() {
  router.push('/content');
}
function showSchedules() {
  router.push('/content/schedule');
}
function showDiscounts() {
  router.push('/content/discounts');
}
function exportContacts() {
  window.open(`/api/contact-csv?token=${token.value}`, 'new');
}

function getPage(path: string): string {
  switch (path) {
    case '/content':
      return 'List';
    case '/content/schedule':
      return 'Schedule';
    case '/content/discounts':
      return 'Discounts';
  }
  return '';
}
</script>
<template>
  <v-app-bar app>
    <v-breadcrumbs :items="['Content', getPage(route.path)]" />
    <v-btn
      flat
      v-if="route.path !== '/content/schedule'"
      color="info"
      @click="showSchedules"
      >Schedule</v-btn
    >
    <v-btn
      flat
      v-if="route.path !== '/content'"
      color="info"
      @click="showContent"
      >List</v-btn
    >
    <v-btn
      flat
      v-if="route.path !== '/content/discounts'"
      color="info"
      @click="showDiscounts"
      >Discounts</v-btn
    >
    <v-btn flat color="info" @click="exportContacts">Export contacts</v-btn>
  </v-app-bar>
</template>
<style>
.v-toolbar {
  z-index: 100 !important;
}
</style>
